
import Vue from 'vue';
import Component from 'vue-class-component';

@Component
export default class MarketingHero extends Vue {
  async signIn() {
    await this.$msal.signIn({ state: 'register' });
  }
}
